import saveCount from '@/components/save-count.vue';
import { BILLING_CYCLE } from '@/common/constants';
import _ from 'lodash';
export default {
  components: { saveCount },
  computed: {
    cyclePrice() {
      const monthly = this.currentPlans.find((p) => p.billing_cycle === BILLING_CYCLE.MONTHLY);
      const annual = this.currentPlans.find((p) => p.billing_cycle === BILLING_CYCLE.ANNUAL);
      const quarterly = this.currentPlans.find((p) => p.billing_cycle === BILLING_CYCLE.QUARTERLY);
      const shortestCyclePlan = _.sortBy(this.currentPlans, p => p.cycleValue)[0];
      return {
        annualPrice: annual?.amount || 0,
        monthlyPrice: monthly?.amount || 0,
        quarterlyPrice: quarterly?.amount || 0,
        shortestCycleMonthlyPrice: (shortestCyclePlan?.amount / shortestCyclePlan?.cycleValue) || 0,
      };
    },
  },
};
